import React, { useEffect } from "react";
import ProjectsSection from "../sections/ProjectsSection";

const ProjectsPage = () => {
	useEffect(() => { window.scrollTo(0, 0); }, []);

	return (
		<div className="page-spacer">
			<div className="page-grid-bg" />
			<div className="page-orb-1" />
			<div className="page-orb-2" />
			<div className="page-orb-3" />
			<ProjectsSection />
		</div>
	);
};

export default ProjectsPage;
